import React from 'react';
import { MDBFileUpload } from 'mdb-react-file-upload';

const DragDrop = (props) => {
  const handleFileChange = (files) => {
    props.selectedFiles(files);
  };
  const acceptedExtensions=props.allowedMimeTypes;  
  return (
    <MDBFileUpload onChange={(files) => handleFileChange(files)} acceptedExtensions={acceptedExtensions}/>
  );
};

export default DragDrop;
